import api from './api.service';

export interface PaymentTerm {
  id: string;
  company_id: string;
  term_name: string;
  days: number;
  description?: string | null;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface PaymentTermSelectionItem {
  id: string;
  term_name: string;
  days: number;
  description?: string | null;
  display_label?: string;
}

export interface PaymentTermFilters {
  is_active?: boolean;
}

export interface CreatePaymentTermPayload {
  term_name: string;
  days?: number;
  description?: string;
  is_active?: boolean;
}

function unwrap<T>(response: unknown): T {
  const data = (response as { data?: unknown })?.data ?? response;
  return ((data as { data?: T })?.data ?? data) as T;
}

class PaymentTermService {
  async list(filters?: PaymentTermFilters): Promise<PaymentTerm[]> {
    const params = new URLSearchParams();
    if (filters?.is_active !== undefined) params.append('is_active', String(filters.is_active));
    const response = await api.get<unknown>(`/finance/payment-terms?${params.toString()}`);
    const raw = unwrap<PaymentTerm[]>(response);
    return Array.isArray(raw) ? raw : [];
  }

  async getForSelection(): Promise<PaymentTermSelectionItem[]> {
    const response = await api.get<unknown>('/finance/payment-terms/selection');
    const raw = unwrap<PaymentTermSelectionItem[]>(response);
    return Array.isArray(raw) ? raw : [];
  }

  async getById(id: string): Promise<PaymentTerm> {
    const response = await api.get<unknown>(`/finance/payment-terms/${id}`);
    return unwrap<PaymentTerm>(response);
  }

  async create(payload: CreatePaymentTermPayload): Promise<PaymentTerm> {
    const response = await api.post<unknown>('/finance/payment-terms', payload);
    return unwrap<PaymentTerm>(response);
  }

  async update(id: string, payload: Partial<CreatePaymentTermPayload>): Promise<PaymentTerm> {
    const response = await api.put<unknown>(`/finance/payment-terms/${id}`, payload);
    return unwrap<PaymentTerm>(response);
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/finance/payment-terms/${id}`);
  }
}

export const paymentTermService = new PaymentTermService();
export default paymentTermService;
